export class IframeResponseTimeoutError extends Error {

  get name() {
    return 'IframeResponseTimeoutError';
  }

}
